import { createContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { auth } from "./firebase"; // Ajusta la ruta

export const AuthContext = createContext();


// const auth = getAuth();
// onAuthStateChanged(auth, async (user) => {
//   if (!user) {
//     try { await signInAnonymously(auth); }
//     catch (e) { console.error("anon sign-in failed", e); }
//   }
// });



export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Escucha los cambios de estado (login, logout)
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
            setLoading(false);
        });
        // Limpia la suscripción
        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div className="flex justify-center items-center h-screen">Cargando...</div>;
    }

    return (
        <AuthContext.Provider value={{ currentUser }}>
            {children}
        </AuthContext.Provider>
    );
}
